import React, { useState } from "react";
import { connect } from "react-redux";
import { createStructuredSelector } from "reselect";
import { useTranslation } from "react-i18next";
import { Tooltip, Menu, Dropdown, Button, Checkbox, Typography } from "antd";
import { selectPatientTableColumns } from "../store/selector";
import ACTIONS from "../store/action";
import ColumnSelectorIcon from "../assets/svg/ColumnSelectorIcon";
import { ColumnsKeys } from "../constant/columns";
import styled from "styled-components";
import { WHITE } from "../constant/colors";

const { Text } = Typography;

const StyledMenu = styled(Menu)`
  overflow: auto;
  max-height: calc(100vh - 330px);

  &::-webkit-scrollbar {
    -webkit-appearance: none;
    width: 15px;
    background-color: ${WHITE};
  }

  &::-webkit-scrollbar-thumb {
    border-radius: 8px;
    border: 4px solid ${WHITE};
    background-color: rgba(0, 0, 0, 0.2);
  }
`;

const ColumnSelectorComponent = ({ tableColumns, setTableColumnsAct }) => {
  const [visible, setVisible] = useState(false);

  const handleVisibleChange = (flag) => setVisible(flag);

  const handleMenuClick = (e) => {
    const currColumn = Object.values(tableColumns)[e.key];
    const newColumn = { ...currColumn, display: !currColumn.display };
    const newTableColumns = { ...tableColumns, [newColumn.key]: newColumn };
    try {
      localStorage.setItem(ColumnsKeys.tableColumns, JSON.stringify(newTableColumns));
    } catch (err) {
      console.error(`could not save column selection: ${err}`);
    }

    setTableColumnsAct(newTableColumns);
  };

  const visibleTableColumns = Object.values(tableColumns).filter((column) => column.hidden !== true);

  const menu = () => (
    <StyledMenu onClick={handleMenuClick}>
      {visibleTableColumns.map((col, index) => (
        <Menu.Item id={`columns-selector-${col.id}`} disabled={col.mandatory} key={index}>
          <Checkbox disabled={col.mandatory} checked={col.display}>
            {col.title}
          </Checkbox>
        </Menu.Item>
      ))}
    </StyledMenu>
  );

  const { t } = useTranslation();
  return (
    <Tooltip title={<Text>{t("column_selector")}</Text>} color={"white"}>
      <Dropdown overlay={menu()} trigger="click" onOpenChange={handleVisibleChange} open={visible}>
        <Button
          data-tm-id="col-selector-btn"
          style={{ marginRight: 5 }}
          type="text"
          onClick={(e) => e.preventDefault()}
          icon={<ColumnSelectorIcon />}
        />
      </Dropdown>
    </Tooltip>
  );
};

const mapStateToProps = createStructuredSelector({
  tableColumns: selectPatientTableColumns
});

const mapDispatchToProps = (dispatch) => ({
  setTableColumnsAct: (columns) => dispatch(ACTIONS.setPatientTableColumns(columns))
});

const ColumnSelector = connect(mapStateToProps, mapDispatchToProps)(ColumnSelectorComponent);

export { ColumnSelector };
